import { useEffect, useState } from 'react'
import * as S from './Page.styled'
import { ProductPrint } from 'components'
import isEven from 'utils/global/isEven'
import { colors } from '@/utils/styling/colors'

export const PagePrint = ({
  page,
  secondPage,
  theme,
  themeOverride,
  index,
  pagePosition = null,
  proof,
  isPDF,
  backgroundType,
  orderId,
  pageSetId,
  nonClippedProducts,
  transparentBackground = false,
  ...props
}) => {
  const [insert, setInsert] = useState([])
  const [isPMRegisterBook, setIsPMRegisterBook] = useState(false)
  const [clipPath, setClipPath] = useState('')

  const createInsertArray = () => {
    const total = page.pageProperties.pageColumns * page.pageProperties.pageRows
    const array = Array.from({ length: total }, () => page)

    if (secondPage) {
      array.push(secondPage)
    }

    setInsert(array)
  }

  useEffect(() => {
    createInsertArray()
    //eslint-disable-next-line
  }, [page])

  useEffect(() => {
    const { product, layout } = page.pageProperties
    if (product === 'Register Book' && layout === 'Full Bleed') {
      setIsPMRegisterBook(true)
    }
  }, [page])

  const environment = isPDF ? 'pdf' : 'preview'

  // This clips 12px bleed on all sides for PDF proof rendering
  const handleClipBleed = () => {
    const isProofRendering = proof && isPDF
    if (isProofRendering) {
      // Simple 12px bleed removal on all sides for proof rendering
      setClipPath('inset(12px 12px 12px 12px)')
    }
  }

  const clipBackgroundColor =
    proof && isPDF && clipPath ? colors('lockedGray5') : null

  return (
    <S.PagePrint
      className="pageItself"
      wrap="wrap"
      key={`${page.pageProperties.pageSetId}+${index}`}
      height={page.pageProperties.pageSize.height}
      width={page.pageProperties.pageSize.width}
      padding={page.pageProperties.pageStartPoints}
      clipBackgroundColor={clipBackgroundColor}
      $transparentBackground={transparentBackground}
      {...props}
    >
      {insert.length > 0 &&
        insert.map((printArea, i) => (
          <ProductPrint
            key={i}
            className="pageContent"
            theme={theme}
            themeOverride={themeOverride}
            paperType={page.pageProperties.paperType}
            page={printArea}
            index={i}
            pagePosition={pagePosition}
            isPDF={isPDF || undefined}
            isPMRegisterBook={isPMRegisterBook}
            isEven={isEven(page.pageProperties.pageNumber)}
            padding={page.pageProperties.pageStartPoints}
            isProof={proof}
            environment={environment}
            pageTwo={
              page?.pageProperties?.pageNumber >= 2 &&
              !page?.pageProperties?.product?.includes('Register')
            }
            backgroundType={backgroundType}
            orderId={orderId}
            pageSetId={pageSetId}
            clipBleed={handleClipBleed}
            clipPath={clipPath}
            nonClippedProducts={nonClippedProducts}
            transparentBackground={transparentBackground}
            {...props}
          />
        ))}
    </S.PagePrint>
  )
}

export default PagePrint
